<template>
  <div id="main" >
    <div class="infoimg">
        <img class="img" src="../assets/info.png">
        <div class="infotip">{{info}}</div>
    </div>
  </div>  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';

export default {
  name: 'main',
  data () {
    return {
      msg: '这里是提交预约页面',        
      wxbaseinfo:{
        openid:'',
        name:'',
        sex:'',
        idnumber:'',
        tel:'',
        deptcode:'',
        departmnet:'',
        serial:'',
        prenum:'',
        visittime:''
      },
      info:'',
      status:'',
      appointdate:'',
      appointampm:''
    }
  },
  created(){       
    // 1、从缓存读取openid    
    var temopenid=localStorage.getItem('wxopenid');
    if(temopenid && temopenid!='undefined'){
        // 缓存存在
        this.wxbaseinfo.openid=temopenid;        
        // 提交排队信息
        this.wxbaseinfo.deptcode=this.$route.params.bianhao;
        this.appointdate=this.$route.params.date;
        this.appointampm=this.$route.params.ampm;
        this.submitinfo();
    }
    else{
        // 缓存不存在，则跳转到授权页
        this.$router.push({path:'/authtest'});
    } 
  },
  methods:{
    // 验证用户信息
    submitinfo(){
      // 验证个人信息
      var api='http://appointmentwebapixct.romis.cn/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.wxbaseinfo.openid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
              if(response.data.result=='false'){
                  // 出错了，则跳到出错处理页面
                  this.$router.push({path:'/err'});
              }
              else{
                if(response.data.data.name==null || response.data.data.name==''){
                    // 没有姓名信息跳转到完善基本信息
                    this.$router.push({name:'baseinfo',params:{'openid':response.data.data.openid}});
                }
                else{                    
                  // 信息完成，则正常显示 
                  this.vipname=response.data.data.name;
                  if(this.vipname){
                      this.wxbaseinfo.name=response.data.data.name;
                      this.wxbaseinfo.sex=response.data.data.sex;
                      this.wxbaseinfo.tel=response.data.data.tel;
                      this.wxbaseinfo.idnumber=response.data.data.idnumber;
                        // 提交排队信息
                        this.submitqueu();
                    }
                }
              }
      }),function(err){
          alert('appointment验证用户失败：' + err);
      }
    },
    // 提交排队信息
    submitqueu(){
      // 验证个人信息
      var api='http://appointmentwebapixct.romis.cn/api/submitqueu';
      Axios.post(api,qs.stringify({
        'name':this.wxbaseinfo.name,
        'cardno':this.wxbaseinfo.idnumber,
        'deptcode':this.wxbaseinfo.deptcode,
        'date':this.appointdate,
        'ampm':this.appointampm,
        'lb':'门诊',
        'fromX':'2'
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
              if(response.data.result=='false'){
                  // 提交排队出错，显示错误信息
                  this.info=response.data.errmsg;
              }
              else{
                  // 提交排队成功，则跳转到排队信息显示界面
                  this.$router.push({name:'dispqueuinfo',params:{'name':response.data.data.name,'departmnet':response.data.data.departmnet,'serial':response.data.data.serial,'prenum':response.data.data.prenum,'visittime':response.data.data.visittime}});
              }
      }),function(err){
          alert('appointment验证用户失败：' + err);
      }
    },
    // 加载系统提示信息
    loadSystemTipInfo(){
        var api='http://appointmentwebapixct.romis.cn/api/systeminfo?cla=servicetip';
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 出错了，则跳到出错处理页面
                // this.$router.push({path:'/err'});
            }
            else{
                console.log(response);
                // 解码用 
                this.introduction=decodeURIComponent(response.data.data);
            }
        }).catch((err)=>{
            alert('appointment获取系统信息失败：' + err);
        })
    }
  }
}
</script>

<style>
#main,/*设置占满*/
html,
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  margin: 0;
}
ul{
    /* background-color: blue;
    text-align: left; */
    margin: 5px;
    padding:0px;
}
.infoimg{
  width: 128px;
  height: 128px;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -50px 0 0 -50px;
}
.infotip{
    height: 32px;
    font-size:18px;
}
</style>


// WEBPACK FOOTER //
// src/components/submitappointment.vue